import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useUploadVesselDocumentsWithAuth from "../utils/useUploadVesselDocumentsWithAuth";
import Spinner from "../../Utils/spinner/loading";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as VatugIcon } from "../../Asset/black.svg";
import { HiOutlineUpload } from "react-icons/hi";
import "./vesselotherdoc.css";

const VesselOtherDocs = () => {
  const navigate = useNavigate();
  const { mutate, isLoading } = useUploadVesselDocumentsWithAuth();
  const [formData, setFormData] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    const newFormData = [...formData];
    newFormData[index] = {
      name: newFormData[index] ? newFormData[index].name : "",
      file: file,
    };
    setFormData(newFormData);
  };

  const handleNameChange = (e, index) => {
    const newName = e.target.value;
    const newFormData = [...formData];
    newFormData[index] = {
      name: newName,
      file: newFormData[index] ? newFormData[index].file : null,
    };
    setFormData(newFormData);
  };

  const addDocumentField = () => {
    setFormData([...formData, { name: "", file: null }]);
  };

 

  const handleSubmit = (e) => {
    e.preventDefault();

    for (const item of formData) {
      if (!item.file) {
        toast.error("Please select a file for all documents.");
        return;
      }

      const uploadData = new FormData();
      uploadData.append("name", item.name);
      uploadData.append("file", item.file);

      mutate(uploadData, {
        onSuccess: () => {
          toast.success("Documents uploaded successfully!");
        },
      });
    }
  };

  const formatFileSize = (size) => {
    if (size >= 1000000) {
      return (size / 1000000).toFixed(2) + " MB";
    } else if (size >= 1000) {
      return (size / 1000).toFixed(2) + " KB";
    } else {
      return size + " bytes";
    }
  };



  return (
    <div className="vessel-upload-container">
      <div className="vessel-upload-header">
        <VatugIcon className="vatug-logo" />
        <span className="header-title">Vessel Upload</span>
        <button className="close-button" onClick={() => navigate("/dashboard/myvessels")}>×</button>
      </div>

      <div className="upload-content">
        <div className="certificate-section">
          <h1>Certificate</h1>
          
          {formData.map((item, index) => (
            <div key={index} className="upload-form">
              <label>Other Certificate {index + 1}</label>
              <input
                type="text"
                placeholder="Input name of document"
                value={item.name}
                onChange={(e) => handleNameChange(e, index)}
                className="document-name-input"
              />
              
              {!item.file ? (
                <div 
                  className="upload-area"
                  onClick={() => fileInputRef.current.click()}
                >
                  <HiOutlineUpload className="upload-icon" />
                  <p className="upload-text">
                    Drop pdf here, <span className="browse-link">or browse</span>
                  </p>
                  <p className="supported-text">Supports: PDF</p>
                  <input
                    type="file"
                    ref={fileInputRef}
                    hidden
                    onChange={(e) => handleFileChange(e, index)}
                    accept=".pdf"
                  />
                </div>
              ) : (
                <div className="file-preview">
                  <span className="file-name">{item.file.name}</span>
                  <span className="file-size">({formatFileSize(item.file.size)})</span>
                  <button 
                    className="change-file"
                    onClick={() => {
                      const newFormData = [...formData];
                      newFormData[index].file = null;
                      setFormData(newFormData);
                    }}
                  >
                    Change
                  </button>
                </div>
              )}
            </div>
          ))}

          <div className="button-group">
            <button className="add-more" onClick={addDocumentField}>
              + Add More Document
            </button>
            <div className="navigation-buttons">
              <button className="back-button" onClick={() => navigate("/veseelprimarydoc")}>
                Go Back
              </button>
              <button 
                className="next-button" 
                onClick={handleSubmit}
                disabled={isLoading || formData.length === 0 || !formData.every(item => item.file && item.name)}
              >
                {isLoading ? <Spinner /> : "Next"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default VesselOtherDocs;
